import { render, staticRenderFns } from "./newUserPaid.vue?vue&type=template&id=49d4334a&scoped=true&"
import script from "./newUserPaid.vue?vue&type=script&lang=js&"
export * from "./newUserPaid.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49d4334a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\admin\\datacenter_web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('49d4334a')) {
      api.createRecord('49d4334a', component.options)
    } else {
      api.reload('49d4334a', component.options)
    }
    module.hot.accept("./newUserPaid.vue?vue&type=template&id=49d4334a&scoped=true&", function () {
      api.rerender('49d4334a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/datalist/newRoleOccupationPaymentRate/newUserPaid.vue"
export default component.exports